import Vue from 'vue';
import recipeTransformer from '../../transformers/recipe';

const success = (resolve, response) => {
  resolve(recipeTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  reject(recipeTransformer.fetch(errors));
};

export default recipe => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/recipe', recipe)
      .then((response) => {
        success(resolve, response.data);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/store.js